import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import Loader from "./Pages/Common/Loader";
import "./App.css";
import ProtectedRoute from "./Pages/Components/Private/Protected/ProtectedRoute";
import PublicRoute from "./Pages/Components/Private/Protected/PublicRoute";
import ScrollToTop from "./ScrollToTop";

// Lazy-loaded components
const HomePage = lazy(() => import("./Pages/Components/HomePage"));
const About = lazy(() => import("./Pages/Components/About/About"));
const Contact = lazy(() => import("./Pages/Components/Contact/Contact"));
const Blog = lazy(() => import("./Pages/Components/Blog/Blog"));
const Login = lazy(() =>
  import("./Pages/Components/Private/Authentication/Login")
);
const OurService = lazy(()=>import('./Pages/Components/OurServices/OurServices'))
const Dashboard = lazy(() =>
  import("./Pages/Components/Private/Dashboard/Dashboard")
);
const ContentManagement = lazy(()=>import('./Pages/Components/Content/Content'))
const Career = lazy(() => import("./Pages/Components/Carrers/Career"));
const App = () => {
  return (
    <>
      <Suspense fallback={<Loader />}>
        <Routes>
          {/* Public route wrapped inside PublicRoute */}
          <Route element={<PublicRoute />}>
            <Route path="/admin" element={<Login />} />
          </Route>

          {/* Protected routes */}
          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard" element={<Dashboard />} />
          </Route>

          {/* Other public routes */}
          <Route path="/" element={<HomePage />} />
           <Route path="/PrivacyPolicy" element={<ContentManagement />} />
                      <Route path="/TermsAndConditions" element={<ContentManagement />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/ourServices" element={<OurService />} />
          <Route path="/careers" element={<Career />} />
          <Route path="/blog" element={<Blog />} />
        </Routes>
        <ScrollToTop />
      </Suspense>
    </>
  );
};

export default App;
